import { render, staticRenderFns } from "./ad-add.vue?vue&type=template&id=51659418&scoped=true&"
import script from "./ad-add.vue?vue&type=script&lang=js&"
export * from "./ad-add.vue?vue&type=script&lang=js&"
import style0 from "./ad-add.vue?vue&type=style&index=0&id=51659418&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=51659418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51659418",
  null
  
)

component.options.__file = "ad-add.vue"
export default component.exports